(function () {
  'use strict';

  const CHAT_ID = 'ShopifyChat';
  const CUSTOM_BTN = '#custom-chat-button';

  /* ---------------- Utilities ---------------- */

  const getChat = () => document.getElementById(CHAT_ID);

  const getToggle = chat => {
    if (!chat || !chat.shadowRoot) return null;
    return [...chat.shadowRoot.querySelectorAll('button')].find(btn =>
      btn.hasAttribute('aria-expanded') ||
      btn.getAttribute('aria-controls')
    );
  };

  const isOpen = chat => chat?.getAttribute('is-open') === 'true';

  /* ---------------- Visibility Control ---------------- */

  function hideAll() {
    const chat = getChat();
    if (!chat) return;

    chat.style.visibility = 'hidden';

    const toggle = getToggle(chat);
    if (toggle) {
      toggle.style.opacity = '0';
      toggle.style.pointerEvents = 'none';
      toggle.style.transform = 'scale(0)';
    }
  }

  function showChat() {
    const chat = getChat();
    if (!chat) return;

    chat.style.visibility = 'visible';
  }

  /* ---------------- Open / Close ---------------- */

  function openChat() {
    const chat = getChat();
    const toggle = getToggle(chat);
    if (!chat || !toggle) return;

    showChat();

    toggle.style.pointerEvents = 'auto';
    toggle.style.opacity = '1';
    toggle.style.transform = 'scale(1)';

    toggle.click();
  }

  function closeChat() {
    const chat = getChat();
    const toggle = getToggle(chat);
    if (!chat || !toggle || !isOpen(chat)) return;

    toggle.style.pointerEvents = 'auto';
    toggle.style.opacity = '1';

    toggle.click();

    // Shopify will try to show launcher again → stop it
    setTimeout(hideAll, 50);
  }

  /* ---------------- Inject Close ✕ ---------------- */

  function injectClose(chat) {
    if (!chat.shadowRoot) return;
    if (chat.shadowRoot.querySelector('.custom-chat-close')) return;

    const header = chat.shadowRoot.querySelector('header');
    if (!header) return;

    const btn = document.createElement('button');
    btn.className = 'custom-chat-close';
    btn.innerHTML = '&times;';
    btn.setAttribute('aria-label', 'Close chat');
    btn.style.cssText = `
      all: unset;
      cursor: pointer;
      font-size: 22px;
      padding: 8px;
      margin-left: auto;
    `;

    btn.onclick = closeChat;
    header.appendChild(btn);
  }

  /* ---------------- Observe Chat ---------------- */

  function observeChat(chat) {
    if (chat.__bound) return;
    chat.__bound = true;

    const observer = new MutationObserver(() => {
      if (isOpen(chat)) {
        injectClose(chat);
      } else {
        hideAll(); // CRITICAL
      }
    });

    observer.observe(chat, {
      attributes: true,
      attributeFilter: ['is-open']
    });

    hideAll(); // initial hard hide
  }

  /* ---------------- Global Observer ---------------- */

  const globalObserver = new MutationObserver(() => {
    const chat = getChat();
    if (chat && chat.shadowRoot) {
      observeChat(chat);
    }
  });

  globalObserver.observe(document.body, {
    childList: true,
    subtree: true
  });

  /* ---------------- External Button ---------------- */

  document.addEventListener('click', e => {
    const btn = e.target.closest(CUSTOM_BTN);
    if (!btn) return;
    e.preventDefault();
    openChat();
  });

  console.log('✓ Shopify Chat fully controlled');
})();
